module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/meet-the-team.json
// module id = 1928
// module chunks = 232750897057113